import(/* webpackMode: "eager" */ "/var/www/apect/src/app/pricing/page.tsx");
